import fetch from '@/utils/fetch';

// 获取订单列表
export function getOrderList(params = {}) {
  return fetch({
    url: '/shop/v1/orders',
    method: 'get',
    params: params
  })
}

// 获取订单信息
export function getOrderInfo(order_id) {
  return fetch({
    url: `/shop/v1/orders/${order_id}`,
    method: 'get'
  })
}

// 获取物流公司列表
export function getShipperList() {
  return fetch({
    url: 'https://fulishe-static.oss-cn-zhangjiakou.aliyuncs.com/static/json/shipping.json',
    method: 'get'
  })
}

// 获取物流信息
export function getShipper(order_id) {
  return fetch({
    url: `/shop/v1/orders/${order_id}/delivery`,
    method: 'get'
  })
}

// 发货
export function createShipper(order_id, data) {
  return fetch({
    url: `/shop/v1/orders/${order_id}/send`,
    method: 'post',
    data: data
  })
}

// 更新订单信息
// export function updateOrder(orderId, data) {
//   return fetch({
//     url: '/cms/orders/' + orderId,
//     method: 'put',
//     data: data
//   });
// }

// 更改物流信息
export function updateLogistic(order_id, data) {
  return fetch({
    url: `/shop/v1/orders/${order_id}/logistic`,
    method: 'put',
    data: data
  })
}
// 上传订单文件
export function uploadOrderFile(data) {
  return fetch({
    url: '/shop/v1/orders/upload',
    headers: { 
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    },
    method: 'post',
    data
  })
}
// 导出订单文件
export function exportOrderFile(data) {
  return fetch({
    url: '/shop/v1/orders/export',
    method: 'post',
    responseType: 'arraybuffer',
    data: data
  })
}

// 更改卖家留言
export function updateShopNote(order_id, data) {
  return fetch({
    url: `/shop/v1/orders/${order_id}/note`,
    method: 'put',
    data
  })
}

// 修改收货地址
export function updateOrderAddress(order_id, data) {
  return fetch({
    url: `/shop/v1/orders/${order_id}/address`,
    method: 'put',
    data
  })
}

// 获取退款列表
export function getRefundList(params) {
  return fetch({
    url: `/shop/v1/aftersales`,
    method: 'get',
    params
  })
}

// 同意退款
export function refundApprove(aftersale_id) {
  return fetch({
    url: `/shop/v1/aftersales/${aftersale_id}/approve`,
    method: 'post'
  })
}

// 拒绝退款
export function refundRefuse(aftersale_id,data) {
  return fetch({
    url: `/shop/v1/aftersales/${aftersale_id}/refuse`,
    method: 'post',
    data
  })
}
